import { enUS } from "@mui/material/locale";
import {enUS as enUS_dataGrid} from "@mui/x-data-grid/locales";
import { enUS as enUS_datePickers } from "@mui/x-date-pickers/locales";
import { enUS as enUS_dateFns } from "date-fns/locale";
import { getTheme } from "../core/theme";
import { importMediaPaths } from "../core/useMedia";
import _config from "./config.js";
// services
import i18n from "../../services/i18n";
// types
import type { Locale } from "date-fns/locale";
import type { Config } from "../../types/config";
import type { Language } from "../../types/misc";

export { default as FLAGS } from "./flags";
export { default as icons } from "../core/icons";
export { useMedia } from "../core/useMedia";

export const config = _config as Config;

importMediaPaths(
	require.context("./media", true, /\.(?:jpe?g|png|webp|avif|gif|svg|mp4)$/), // filter not possible to extract into a constant
	require.context("../core/media", true, /\.(?:jpe?g|png|webp|avif|gif|svg|mp4)$/) // filter not possible to extract into a constant
);

const language = i18n.resolvedLanguage as Language;

const l10nDateFns = {
	en: enUS_dateFns,
} as const satisfies Record<string, Locale>;
export const localeDateFns = l10nDateFns[language] as Locale;

const l10nMuiTheme = {
	en: enUS,
} as const;

const l10nDataGrid = {
	en: enUS_dataGrid,
} as const;

const l10nDatePickers = {
	en: enUS_datePickers,
} as const;

export const muiTheme = getTheme("#d4621c", l10nMuiTheme[language], l10nDataGrid[language], l10nDatePickers[language]);
